import { renderButton_unstable } from '@fluentui/react-button';

/**
 * Renders the final JSX of the ToolbarButton component, given the state.
 */
export const renderToolbarButton = renderButton_unstable;
